import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  fetchEnterpriseByUser,
  dashboardLogin
} from '../actions/sessionActions';
import {
  Select,
  Button,
  Row,
  Col,
  message,
  Input,
  Alert,
  Spin,
  Icon
} from 'antd';
const { Option } = Select;
const { TextArea } = Input;
import axios from 'axios';
import { APIs } from '../utils/apis';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export class CreateShippingLabels extends Component {
  state = {
    formInput: {
      enterprise: null,
      awbs: [],
      input: ''
    },
    selectedEnterprise: null,
    enterpriseUserToken: null,
    accessLoading: true,
    enterpriseLoginLoading: false,
    awbsLeft: [],
    isSubmitting: false,
    successAwbs: []
  };

  componentDidMount() {
    this.props
      .fetchEnterpriseByUser()
      .finally(() => this.setState({ accessLoading: false }));
  }

  handleChange = (key, value) => {
    const { formInput } = this.state;
    formInput[key] = value;
    this.setState({ formInput });
  };

  handleEnterpriseChange = index => {
    const { metadata } = this.props;
    if (index === undefined || index === null || index < 0) {
      this.setState({
        selectedEnterprise: null,
        enterpriseUserToken: null,
        enterpriseLoginLoading: false,
        formInput: {
          ...this.state.formInput,
          enterprise: null
        }
      });
      return;
    }
    const enterprise = metadata.enterprise.list[index];
    this.setState({
      selectedEnterprise: enterprise,
      enterpriseUserToken: null,
      enterpriseLoginLoading: true,
      formInput: {
        ...this.state.formInput,
        enterprise: enterprise.key
      }
    });
    this.props
      .dashboardLogin(enterprise.id)
      .then(res => {
        if (!res || !Array.isArray(res.result)) {
          this.setState({ enterpriseLoginLoading: false });
          message.error('Failed to load enterprise users');
          return;
        }
        const ok =
          (res.result && res.result.length > 0) ||
          (res.meta &&
            res.meta.status === 200 &&
            res.result &&
            res.result.length > 0);
        if (!ok || !res.result[0].sub_token) {
          this.setState({ enterpriseLoginLoading: false });
          message.info(
            'There is some issue with this enterprise, we request you to contact tech team'
          );
          return;
        }
        const firstUserSubToken = res.result[0].sub_token;
        this.setState({
          enterpriseUserToken: firstUserSubToken,
          enterpriseLoginLoading: false
        });
      })
      .catch(() => {
        this.setState({ enterpriseLoginLoading: false });
        message.error('Failed to load enterprise users');
      });
  };

  handleInputChange = e => {
    const { formInput } = this.state;
    let awbs = e.target.value.replace(/\n/g, ',').split(',');
    awbs = awbs.filter(awb => awb !== '');
    formInput.awbs = awbs;
    formInput.input = e.target.value;
    this.setState({ formInput });
  };

  handleSubmit = () => {
    const { formInput, enterpriseUserToken } = this.state;
    if (!enterpriseUserToken) {
      return message.info(
        'Please wait for enterprise login to finish, then try again'
      );
    }

    if (formInput.awbs.length < 1) {
      return message.info('Please enter AWBs');
    }
    this.setState({ isSubmitting: true, awbsLeft: [], successAwbs: [] });
    const promiseArray = formInput.awbs.map(awb =>
      axios({
        url: `${APIs.SHIPPING_LABEL.REGENERATE}&waybill=${awb}`,
        method: 'GET',
        headers: {
          Authorization: `Token ${enterpriseUserToken}`
        }
      })
    );
    Promise.all(promiseArray)
      .then(data => {
        let awbsLeft = [];
        let successAwbs = [];
        for (let index = 0; index < data.length; index++) {
          if (data[index].data.meta.status !== 200) {
            awbsLeft.push(formInput.awbs[index]);
          } else if (data[index].data.meta.status === 200) {
            successAwbs.push({
              awb: formInput.awbs[index],
              url: data[index].data.result.shipping_label
            });
          }
        }
        this.setState({ isSubmitting: false, successAwbs });
        if (awbsLeft.length === 0) {
          message.success('We have re-generated shipping labels for all awbs.');
        } else {
          message.info('There is some issue in few awbs.');
        }
        this.setState({ awbsLeft });
      })
      .catch(() => {
        this.setState({ isSubmitting: false });
        message.error(
          'Failed to regenerate shipping labels. Please try again.'
        );
      });
  };

  handleReset = () => {
    this.setState({
      formInput: { enterprise: null, awbs: [], input: '' },
      awbsLeft: [],
      selectedEnterprise: null,
      enterpriseUserToken: null,
      enterpriseLoginLoading: false
    });
  };

  render() {
    const {
      awbsLeft,
      successAwbs,
      accessLoading,
      selectedEnterprise,
      enterpriseLoginLoading,
      enterpriseUserToken
    } = this.state;
    const { metadata } = this.props;
    const userAccessType = metadata.userAccessType ?? 'restricted';

    if (accessLoading) {
      return <Spin indicator={antIcon} />;
    }

    if (metadata.enterprise.error) {
      return (
        <div>
          <Alert
            type="error"
            showIcon
            message="Could not load enterprises"
            description="Please refresh the page or try again later."
          />
        </div>
      );
    }

    if (userAccessType === 'restricted') {
      return (
        <div>
          <Alert
            type="warning"
            showIcon
            message="Restricted access"
            description="This page is available only to users with admin access."
          />
        </div>
      );
    }

    return (
      <div>
        <h2>Re-generate enterprise shipping label</h2>
        <Row className="margin-bottom-10">
          <Col span={3}>
            <span>Enterprise:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder="Please select an enterprise"
              optionFilterProp="children"
              value={
                selectedEnterprise && selectedEnterprise.id
                  ? selectedEnterprise.name
                  : undefined
              }
              onChange={this.handleEnterpriseChange}
              loading={enterpriseLoginLoading}
              allowClear
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {metadata.enterprise.list.map((enterprise, i) => (
                <Option key={i} value={i}>
                  {enterprise.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <span>AWBs:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <TextArea
              rows={8}
              name="input"
              value={this.state.formInput.input}
              onChange={this.handleInputChange}
              placeholder="Enter one AWB number in each line"
            />
          </Col>
          <Col span={24} className="margin-bottom-20">
            <Button
              type="primary"
              onClick={this.handleSubmit}
              loading={this.state.isSubmitting}
              disabled={enterpriseLoginLoading || !enterpriseUserToken}
            >
              Submit
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={this.handleReset}
              disabled={this.state.isSubmitting}
            >
              Clear
            </Button>
          </Col>

          {awbsLeft.length > 0 ? (
            <Fragment>
              <Col span={24} className="margin-bottom-20">
                <Alert
                  message="We suggest you re-generate below awbs again. Sometimes we have seen some issues in regenerate API."
                  type="info"
                />
              </Col>
              <Col span={24} className="margin-bottom-10">
                <h2>Failed AWBs:</h2>
                <pre>
                  <ul style={{ maxHeight: '150px' }}>
                    {awbsLeft.map((awb, i) => (
                      <li key={i}>{awb}</li>
                    ))}
                  </ul>
                </pre>
              </Col>
            </Fragment>
          ) : null}
          {successAwbs.length > 0 ? (
            <Col span={24} className="margin-bottom-20">
              <h2>Result:</h2>
              <table className="ant-table ant-table-small width-100pt">
                <thead className="ant-table-thead">
                  <tr>
                    <th>AWB</th>
                    <th>URL</th>
                  </tr>
                </thead>
                <tbody className="ant-table-tbody">
                  {successAwbs.map((item, i) => (
                    <tr key={i}>
                      <td>{item.awb}</td>
                      <td>
                        <a href={item.url} target="_blank" rel="noreferrer">
                          {item.url}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Col>
          ) : null}
        </Row>
      </div>
    );
  }
}

CreateShippingLabels.propTypes = {
  config: PropTypes.object,
  location: PropTypes.object,
  metadata: PropTypes.object,
  fetchEnterpriseByUser: PropTypes.func,
  dashboardLogin: PropTypes.func
};

CreateShippingLabels.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  shippingLabels: state.session.shippingLabels
});

const mapDispatchToProps = dispatch => ({
  fetchEnterpriseByUser: () => dispatch(fetchEnterpriseByUser()),
  dashboardLogin: enterpriseId => dispatch(dashboardLogin(enterpriseId))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateShippingLabels)
);
